<template>
	<div class="myOrderContainer">
		<div class="msg-center-nav">
			<div class="msg-categories">
				<div v-for="category in categories" :key="category.key" class="category-item"
					:class="{ 'active': activeCategory === category.key }" @click="switchCategory(category.key)">
					{{ category.name }}
				</div>
			</div>
		</div>
		<div class="activityList" v-if="avtivityData.length">
			<div class="activity" v-for="(item,index) in avtivityData" :key="index"
				@click="naviToActivityDetails(item)">
				<img class="activityImage" :src="item.banner" />
				<div class="activityInfo">
					<div class="activityTitle ellipsis-1">{{item.title}}</div>
					<div class="activityTime">活动时间：{{item.action_time}} — {{item.end_time}}</div>
					<div class="activityEndTime">报名截止：{{item.last_time}}</div>
					<div class="activityPublishTime">发布时间：{{item.create_time}}</div>
				</div>
				<img class="statusIcon" src="../assets/WonderfulActivities/iconA.png" v-if="item.status == '进行中'" />
				<img class="statusIcon" src="../assets/WonderfulActivities/iconB.png" v-if="item.status == '已截止'" />
				<img class="deleteIcon" src="../assets/Personal/iconB.png" @click.stop="delActivity(item)" />
			</div>
		</div>
		<el-empty description="暂无数据" v-else></el-empty>
		<PagePagination style="padding: .4rem 0 0;" :currentPage="currentPage" :total="total"
			@current-change="onPageChange" />
	</div>
</template>

<script>
	export default {
		name: "MyActivity",
		data() {
			return {
				avtivityData: [],
				categories: [{
						key: '',
						name: '全部'
					},
					{
						key: '1',
						name: '未开始'
					},
					{
						key: '2',
						name: '进行中'
					},
					{
						key: '3',
						name: '已过期'
					}
				],
				activeCategory: '',
				currentPage: 1, // 当前页码
				total: 0, // 总条数
			}
		},
		mounted() {
			this.myActivityList()
		},
		methods: {
			onPageChange(newPage) {
				this.currentPage = newPage
				this.myActivityList()
			},
			// 切换分类
			switchCategory(category) {
				this.activeCategory = category;
				this.myActivityList()
			},
			//我的报名活动) type ==1 未开始  ==2进行中 ==3 已过期
			myActivityList() {
				this.$api.post('/Release/my_activity_list', {
					p: this.currentPage,
					type: this.activeCategory
				}).then(res => {
					if (res.code == 1) {
						this.total = res.data.count
						this.avtivityData = res.data.list
					}
				}).catch(err => {
					console.log(err);
				})
			},
			naviToActivityDetails(item) {
				this.$emit('lookDetails', item)
			},
			delActivity(item) {
				this.$confirm('确认删除当前活动吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.post('/Release/my_activity_del', {
						aid: item.aid
					}).then(res => {
						if (res.code == 1) {
							this.$message.success(res.msg)
							this.myActivityList()
						}
					}).catch(err => {
						console.log(err);
					})
				}).catch(() => {

				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.myOrderContainer {
		display: flex;
		flex-direction: column;
		padding: .24rem .4rem;
	}

	/* 消息分类导航样式 */
	.msg-center-nav {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: .01rem solid rgba(204, 204, 204, .4);
	}

	.msg-categories {
		display: flex;
		gap: .32rem;
	}

	.category-item {
		font-weight: 400;
		font-size: .16rem;
		color: #040404;
		cursor: pointer;
		padding: .24rem 0 .15rem;
		position: relative;
		transition: color 0.3s ease;
	}

	.category-item:hover {
		font-weight: 500;
		font-size: .16rem;
		color: #6B3503;
	}

	.category-item.active {
		font-weight: 500;
		font-size: .16rem;
		color: #6B3503;
	}

	.category-item::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: .02rem;
		background-color: #693200;
		transform: scaleX(0);
		transform-origin: left center;
		transition: transform 0.3s ease;
	}

	.category-item.active::after {
		transform: scaleX(1);
	}

	.activityList {
		margin: .12rem auto 0;
		width: 100%;
		display: flex;
		flex-wrap: wrap;

		.activity:nth-child(2n) {
			margin-right: 0;
		}

		.activity {
			margin-top: .12rem;
			margin-right: .18rem;
			display: flex;
			flex-direction: column;
			width: 4.28rem;
			background: #FFFFFF;
			box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
			border-radius: .12rem;
			overflow: hidden;
			position: relative;
			cursor: pointer;

			.statusIcon {
				position: absolute;
				width: .48rem;
				height: .22rem;
				right: 0;
				bottom: .92rem;
			}

			.deleteIcon {
				position: absolute;
				width: .18rem;
				height: .18rem;
				right: .24rem;
				bottom: .24rem;
				cursor: pointer;
			}

			.activityImage {
				width: 4.28rem;
				height: 2.28rem;
				overflow: hidden;
				object-fit: cover;
			}

			.activityInfo {
				display: flex;
				flex-direction: column;
				padding: .24rem .26rem;

				.activityTitle {
					margin-bottom: .08rem;
					font-weight: 500;
					font-size: .16rem;
					color: #693200;
					line-height: .24rem;
				}

				.activityTime,
				.activityEndTime,
				.activityPublishTime {
					font-weight: 400;
					font-size: .12rem;
					color: #999999;
					line-height: .2rem;
				}
			}
		}
	}
</style>